<template>
  <div>
    <div>
      <QS-h4-title title="关联订单信息" />
    </div>
    <form-text-box
      :column="2"
      :dataList="m_relationOrderInfo"
      :model="m_relationOrderInfoModel"
    />
  </div>
</template>

<script>
import selectOption from '@/store/dict/selectOptionDict'

export default {
  data() {
    return {}
  },
  props: {
    m_relationOrderInfo: {
      type: Array,
      default: () => [],
    },
    m_relationOrderInfoModel: {
      type: Object,
      default: () => {},
    },
    relatedType: {
      type: [Number],
      default: -1,
    },
  },
  created() {
    // eslint-disable-next-line vue/no-mutating-props
    this.m_relationOrderInfoModel.relatedTypeName = selectOption.rderRelatedReason[Number(this.relatedType)]
  },
}
</script>

<style>

</style>
